<div class="container-fluid edit-page">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10 pl-0 pr-0">
      <div class="card">
        <div class="card-body">
          <!-- HEADER -->
          <div class="tw:!my-6 tw:flex tw:items-center tw:justify-between">
            <div class="tw:flex tw:cursor-pointer tw:gap-4">
              <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 opacity-50" routerLink="../">{{ 'SALES_LIST_PAGE.sales' | translate }}</h3>
              <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0">
                {{ 'SALES_LIST_PAGE.payments' | translate }}
              </h3>
              <h3 class="tw:!font-extrabold color-primary tw:!text-base tw:md:!text-2xl tw:py-2 tw:!mb-0 opacity-50" routerLink="../commissions">
                {{ 'SALES_LIST_PAGE.commissions' | translate }}
              </h3>
            </div>

            <div class="tw:hidden tw:md:block">
              <button class="btn btn-md btn-primary" (click)="newPayment()">
                {{ 'GENERAL.new' | translate }}
                <i class="material-icons icon">add</i>
              </button>
            </div>
          </div>
          <form
            [formGroup]="searchForm"
            class="tw:mb-6 tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-4 tw:md:flex-row"
            [class.tw:opacity-50]="loading()"
            [class.tw:pointer-events-none]="loading()"
          >
            <div class="tw:w-full tw:md:w-2/5">
              <app-text-input
                formControlName="search"
                [hasMarginB]="false"
                icon="search"
                [hasMarginB]="false"
                placeholder="{{ 'SALES_LIST_PAGE.filterFieldPlaceholder' | translate }}"
              />
            </div>
            <div class="tw:flex tw:gap-4">
              @if (currentUser()?.role !== 'provider' && (availableUsers() ?? []).length > 1) {
              <div dropdown container="body" placement="bottom right">
                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                  {{ searchForm.value?.createdByUser?.name || ('SALES_LIST_PAGE.allUsers' | translate) }}
                  <i class="material-icons icon">group</i>
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="setCreatedByUser(null)">
                      {{ 'SALES_LIST_PAGE.allUsers' | translate }}
                    </a>
                  </li>
                  @for (user of availableUsers(); let i = $index; track i) {
                  <li>
                    <a class="dropdown-item" (click)="setCreatedByUser(user)">
                      {{ user.name }}
                    </a>
                  </li>
                  }
                </ul>
              </div>
              }
              <div dropdown container="body" placement="bottom right">
                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                  {{ searchForm.value?.paymentMethod?.label || ('SALES_LIST_PAGE.paymentMethod' | translate) }}
                  <i class="material-icons icon">arrow_drop_down</i>
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="setPaymentMethod(null)">
                      {{ 'GENERAL.all' | translate }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" (click)="setPaymentMethod('online')">
                      {{ 'PAYMENTS_LIST_PAGE.paymentsOnline' | translate }}
                    </a>
                  </li>
                  @for (method of paymentMethods(); let i = $index; track i) {
                    <li>
                      <a class="dropdown-item" (click)="setPaymentMethod(method)">
                        {{ method.label }}
                      </a>
                    </li>
                  }
                </ul>
              </div>
              <div dropdown container="body" placement="bottom right">
                <button dropdownToggle class="btn btn-md btn-secondary" type="button">
                  @if (selectedDateRange().value === "custom") {
                  {{ searchForm.value.startDate | date : 'shortDate' }} - {{ searchForm.value.endDate | date : 'shortDate' }}
                  } @else {
                  {{ selectedDateRange().label }}
                  }

                  <i class="material-icons icon">arrow_drop_down</i>
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                  @for (range of filterDateRanges; let i = $index; track i) {
                  <li>
                    <a class="dropdown-item" (click)="setDateRange(range)">
                      {{ range.label }}
                    </a>
                  </li>
                  }
                </ul>
              </div>
            </div>
          </form>

          @if (loading()) {
          <app-loader />
          } @else {
          <!-- TOTALS  -->
          <div class="tw:mb-6 tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:bg-primary-50 tw:p-4 tw:gap-5 tw:overflow-x-auto">
            <div class="tw:min-w-[100px] tw:text-primary tw:text-center">
              <h6 class="tw:!text-xl tw:!font-bold">{{ payymentsData().summary.totalPayments }}</h6>
              <div class="tw:text-xs">{{ 'SALES_LIST_PAGE.paymentsCount' | translate }}</div>
            </div>
            <div class="tw:min-w-[100px] tw:text-primary tw:text-center">
              <h6 class="tw:!text-xl tw:!font-bold">
                {{ payymentsData().summary?.totalOnlineAmount ?? 0 | merchantCurrency }}
              </h6>
              <div class="tw:text-xs">{{ 'PAYMENTS_LIST_PAGE.paymentsOnline' | translate }}</div>
            </div>
            @for (method of paymentMethods(); let i = $index; track i) {
              <div class="tw:min-w-[100px] tw:text-primary tw:text-center">
                <h6 class="tw:!text-xl tw:!font-bold">
                  {{ payymentsData().summary?.paymentMethods?.[method.value]?.totalAmount ?? 0 | merchantCurrency }}
                </h6>
                <div class="tw:text-xs">{{ method.label }}</div>
              </div>
            }
            <div class="tw:min-w-[100px] tw:text-primary tw:text-center">
              <h6 class="tw:!text-xl tw:!font-bold">{{ payymentsData().summary.totalAmount | merchantCurrency }}</h6>
              <div class="tw:text-xs">{{ 'GENERAL.total' | translate }}</div>
            </div>
          </div>

          @if (payymentsData().payments.length === 0) {
          <!-- Empty satate -->
          <div class="empty-state">
              <div class="text-center">
              <div class="tw:rounded-full tw:w-12 tw:h-12 tw:bg-primary-50 tw:flex tw:items-center tw:justify-center tw:mx-auto mb-3">
                  <i class="material-icons tw:text-primary-300">view_list</i>
              </div>
              <p class="text-secondary tw:mb-3">{{ 'PAYMENTS_LIST_PAGE.emptyState.description' | translate }}</p>
              </div>
          </div>
          } @else {
          <!-- TABLE  -->
          <div class="tw:w-full tw:overflow-x-auto">
            <div class="tw:table tw:table-auto tw:w-full tw:min-w-[640px]">
              <div class="tw:table-header-group">
                <div class="tw:table-row tw:bg-primary-50 tw:text-xs tw:font-semibold tw:text-neutral-500 tw:shadow-menu">
                  <div class="tw:table-cell tw:p-2">{{ 'PAYMENTS_LIST_PAGE.salesCode' | translate }}</div>
                  <div class="tw:table-cell tw:p-2">{{ 'GENERAL.date' | translate }}</div>
                  <div class="tw:table-cell tw:p-2">{{ 'PAYMENTS_LIST_PAGE.nameVat' | translate }}</div>

                  <div class="tw:table-cell tw:p-2">{{ 'PAYMENTS_LIST_PAGE.registeredBy' | translate }}</div>
                  <div class="tw:table-cell tw:p-2">{{ 'PAYMENTS_LIST_PAGE.paymentMethod' | translate }}</div>
                  <div class="tw:table-cell tw:p-2">{{ 'PAYMENTS_LIST_PAGE.value' | translate }}</div>
                </div>
              </div>
              <div class="tw:table-row-group tw:py-2 tw:text-xs tw:text-neutral-500">
                @for (line of payymentsData().payments; let i = $index; track line.lineKind + '-' + line.id) {
                <div class="tw:table-row tw:shadow-menu tw:cursor-pointer tw:hover:bg-neutral-50" [class.bg-primary-50]="i % 2 == 1" (click)="openSaleDetails(line.sale)">
                  <div class="tw:table-cell tw:p-2 tw:align-middle tw:text-primary-500">
                    @if (line.lineKind === 'cancellation') {
                      @if (line.creditNoteReferences?.length) {
                        @for (reference of line.creditNoteReferences; track reference) {
                          <div>{{ reference }}</div>
                        }
                      } @else {
                        {{ line?.sale?.code || '-' }}
                      }
                    } @else {
                      <div>{{ line?.sale?.invoiceReference || line?.sale?.code || '-' }}</div>
                      @if (line?.sale?.status === 'draft') {
                        <div class="tw:italic tw:text-neutral-400">{{ 'SALES_STATUS.draft' | translate }}</div>
                      }
                    }
                  </div>
                  <div class="tw:table-cell tw:p-2">
                    <div>{{ line.createdAt | date : 'dd/MM/yyyy' }}</div>
                    <div>{{ line.createdAt | date : 'HH:mm' }}</div>
                  </div>
                  <div class="tw:table-cell tw:p-2">
                    @if (line?.sale?.clientName) {
                      <div>{{ line.sale.clientName }}</div>
                    } @else {
                      <div class="tw:italic tw:text-neutral-400">{{ 'GENERAL.walkInCustomer' | translate }}</div>
                    }
                    @if (line?.sale?.clientVatNumber) {
                      <div>{{ line.sale.clientVatNumber }}</div>
                    }
                  </div>
                  <div class="tw:table-cell tw:p-2 tw:align-middle">
                    {{ line.createdByUser?.name || ('PAYMENTS_LIST_PAGE.bukPay' | translate) }}
                  </div>
                  <div class="tw:table-cell tw:p-2 tw:align-middle">
                    @if (line.lineKind === 'cancellation') {
                      @if (line.paymentMethod) {
                        {{ line.paymentMethod | paymentMethod:false }}
                      } @else {
                        -
                      }
                    } @else {
                      {{ line.paymentMethod | paymentMethod:line.isOnlinePayment }}
                    }
                  </div>
                  <div class="tw:table-cell tw:p-2 tw:align-middle">
                    @if (line.lineKind === 'cancellation') {
                      <span class="tw:text-error-800">{{ -line.amount | merchantCurrency }}</span>
                    } @else {
                      {{ line.amount | merchantCurrency }}
                    }
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
          } }
        </div>
      </div>
    </div>
  </div>
</div>
